import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route change:
 *  - If URL has a #hash → scroll to that element (deferred until it mounts).
 *  - Otherwise → scroll to top.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Defer so the target section has time to render after route change
      const t = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 60);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    return undefined;
  }, [pathname, hash]);

  return null;
}
